// extracted by mini-css-extract-plugin
export var standaloneTable = "_dp-0";
export var standaloneTableWithBodyFill = "_dp-1";
export var withExtraHeader = "_dp-2";